import React, { Component, Fragment } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaEnvelope from 'react-icons/lib/fa/envelope';
import FaPhone from 'react-icons/lib/fa/phone';

import A from 'wanderu-component-react-router-link';
import {
    Button,
    CarrierLogo,
    SectionTitle,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import ccConfig from '../../../../../config/carriercontact.locale';

import styles from './RegionalData.scss';

const NUM_CARRIERS_TO_SHOW = 5;

function CarrierContactCard({ carrier, isHidden }) {
    const {
        name,
        phone,
        active,
        url_slug: url,
        carrier_id: id,
        support_email: email,
    } = carrier;

    const contactInfo = (
        <Fragment>
            <SectionTitle className={styles.carrierName}>
                {name}
            </SectionTitle>
            <CarrierLogo
                carrierCode={id}
                carrierName={name}
                className={styles.logo}
                seoLazyload
            />
        </Fragment>
    );

    return (
        <li
            className={classNames(
                styles.carrierCard,
                { [styles.hidden]: isHidden },
            )}
        >
            {active
                ? (
                    <A className={styles.contactInfo} href={`/carrier/${url}/`}>
                        {contactInfo}
                    </A>
                )
                : (
                    <div className={styles.contactInfo}>
                        {contactInfo}
                    </div>
                )}
            <div className={`${styles.contactInfo} ${styles.rightColumn}`}>
                {email && (
                    <div className={styles.contact}>
                        <A
                            className={styles.contactText}
                            href={`mailto:${email}`}
                            native
                        >
                            {email}
                        </A>
                        <FaEnvelope className={styles.contactIcon} />
                    </div>
                )}
                {phone && (
                    <div className={styles.contact}>
                        <A
                            className={styles.contactText}
                            href={`tel:${phone}`}
                            native
                        >
                            {phone}
                        </A>
                        <FaPhone className={styles.contactIcon} />
                    </div>
                )}
            </div>
        </li>
    );
}

class RegionalData extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hideExtraCarriers: true,
        };
    }

    _toggleSeeMoreButton = () => {
        this.setState((currentState) => ({
            hideExtraCarriers: !currentState.hideExtraCarriers,
        }));
    }

    render() {
        const {
            t,
            id,
            data,
            region,
            isHidden,
        } = this.props;
        const {
            hideExtraCarriers,
        } = this.state;

        if (!data || !data.length) {
            return;
        }

        return (
            <li
                className={classNames(
                    styles.regionalData,
                    { [styles.hidden]: isHidden },
                )}
                id={id}
            >
                <SectionTitle>
                    {region}
                </SectionTitle>
                <ul className={styles.carrierCardContainer}>
                    {data.map((carrier, index) => (
                        <CarrierContactCard
                            carrier={carrier}
                            isHidden={index > NUM_CARRIERS_TO_SHOW - 1 && hideExtraCarriers}
                            key={carrier.carrier_id}
                        />
                    ))}
                </ul>
                {data.length > NUM_CARRIERS_TO_SHOW && (
                    <Button
                        className={styles.seeMore}
                        onClick={this._toggleSeeMoreButton}
                        unstyled
                    >
                        {hideExtraCarriers
                            ? t('showMoreCarriers')
                            : t('showLessCarriers')}
                    </Button>
                )}
            </li>
        );
    }
}

RegionalData.propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        phone: PropTypes.string,
        url_slug: PropTypes.string,
        carrier_id: PropTypes.string,
        support_email: PropTypes.string,
    })).isRequired,
    region: PropTypes.string.isRequired,
};

export { CarrierContactCard, RegionalData };
export default localize(RegionalData, ccConfig.namespace);
